export type HubspotCreateContactHTTPRequest = {
  email: string
  cnpj: string
  name: string
  phone: string
  utmSource: string
  utmMedium: string
  utmCampaign: string
  utmTerm: string
  utmContent: string
}

export type HubspotCreateContactHTTPResponse = {
  message: string
  data: {
    email: string
    cnpj: string
    name: string
    phone: string
    origin_url: string
    company: {
      companyName: string
      businessNature: string
      tradeName: string | null
      zipCode: string
      state: string
      city: string
      optedForSimple: string
      optedForMei: string
      cnaePrimary: string
      cnaeSecondary: string
      taxRegistered: string
    }
  }
}

export enum HubspotEventType {
  LOGIN = 'event_score_login',
}

export enum HubspotProductType {
  PRODUCT_NFE = 'product_nfe',
  PRODUCT_NFCE = 'product_nfce',
  PRODUCT_NFSE = 'product_nfse',
  PRODUCT_CTE = 'product_cte',
  PRODUCT_MDFE = 'product_mdfe',
}

export type HubspotSendEventHTTPRequest = {
  email: string
  cnpj: string
  product: HubspotProductType
  event_type: HubspotEventType
  timestamp: number
  metadata?: Record<string, any>
}

export type HubspotSendEventHTTPResponse = {
  message: string
  data: {
    product: HubspotProductType
    email: string
    cnpj: string
    event_type: HubspotEventType
    timestamp: string
  }
}
